<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">Cumulocity Details</h5>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Server URL</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.serverUrl" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Cumulocity Email Login</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.emailLogin" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Cumulocity Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.password" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': serverAddressError }"
                        v-model="serverData.cumulocity.ftpServerAddress"
                        @change="validateServerAddress" />
                    <div class="invalid-feedback">Please follow IP address format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': portNumberError }"
                        v-model="serverData.cumulocity.ftpPortNumber"
                        @change="validatePort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.ftpUsername" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.ftpPassword" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Config File Path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.cumulocity.ftpConfigFilePath" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            serverAddressError: false,
            portNumberError: false
        }
    },
    props: ['serverData'],
    methods: {
        validateServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.serverData.cumulocity.ftpServerAddress) || this.serverData.cumulocity.ftpServerAddress === 'NULL') {
                this.serverAddressError = false
            } else {
                this.serverAddressError = true
            }
        },
        validatePort() {
            if((/^[0-9]+$/.test(this.serverData.cumulocity.ftpPortNumber) && (parseInt(this.serverData.cumulocity.ftpPortNumber) > 0 && parseInt(this.serverData.cumulocity.ftpPortNumber) < 65536)) || this.serverData.cumulocity.ftpPortNumber === 'NULL') {
                this.portNumberError = false
            } else {
                this.portNumberError = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/CumulocityDetails.vue